/** @format */

export const DEFAULT_TEST_ID = 'product-comparison-item__out-of-stock';
